<template>
  <div class="ui fullscreen modal" ref="modal">
    <div class="header">{{ $t("bulk code result") }}</div>
    <i class="close icon" @click="$emit('close')"></i>
    <div class="scrolling content">
      <div class="ui info visible message" v-if="false">
        <div class="content">
          <div class="header">
            {{ $t("upload result") }}
          </div>
          <p>
            {{
              $t(
                "the list contains only the code requests created, the ones who arent in this list were dismissed due to validations",
              )
            }}
          </p>
        </div>
      </div>
      <table class="ui celled table" v-if="false">
        <thead>
          <tr>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("email") }}</th>
            <th>{{ $t("bill or ticket number") }}</th>
            <th>{{ $t("card or notebook serial number") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(dt, idx) in data" :key="idx">
            <td data-label="Name">
              {{ dt.setup.customer_name }}
            </td>
            <td data-label="Name">{{ dt.setup.customer_email }}</td>
            <td data-label="Name">{{ dt.setup.bill_or_ticket_number }}</td>
            <td data-label="Name">{{ dt.setup.card_or_notebook_serial }}</td>
          </tr>
        </tbody>
      </table>
      <table class="ui celled table">
        <thead>
          <tr>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("email") }}</th>
            <th>{{ $t("bill or ticket number") }}</th>
            <!-- <th>{{ $t("card or notebook serial number") }}</th> -->
            <th>{{ $t("result") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(dt, idx) in rows" :key="idx">
            <td data-label="Name">{{ dt.name }}</td>
            <td data-label="Name">{{ dt.email }}</td>
            <td data-label="Name">{{ dt.bill }}</td>
            <!-- <td data-label="Name">{{ dt.serie }}</td> -->
            <td data-label="Name">
              <div class="ui label" v-if="dt.result">
                <i class="green check icon "></i>{{ $t("requested") }}
              </div>
              <div class="ui label" v-if="!dt.result">
                <i class="red remove icon "></i>{{ $t("missed") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="actions">
      <div class="ui cancel blue button">{{ $t("close") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "",
  props: {},
  computed: {},
  data() {
    return {
      data: [],
      rows: [],
    };
  },
  methods: {
    show(r, rows) {
      let vm = this;
      vm.data = r;
      vm.rows = rows
        .slice(1, rows.length)
        .map((r) => {
          return {
            name: r[0],
            email: r[1],
            bill: r[2],
            type: r[3],
            gpu: r[4],
            brand: r[5],
            serie: r[6],
          };
        })
        .map((_r) => {
          let trgt = r.find((x) => {
            return (
              x.setup.customer_email == _r.email &&
              x.setup.bill_or_ticket_number == _r.bill
            );
          });
          _r.result = trgt ? true : false;
          return _r;
        });

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {},
        })
        .modal("show");
    },
  },
  mounted() {},
};
</script>

<style scoped>
.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.is-capatilize {
  text-transform: capitalize !important;
}
/*  SIDE BAR BUTTONS    */
.pbundle {
  align-items: center !important;
}
.pbundle div button {
  border-radius: 2rem !important;
}
.pbundle div .cgray {
  font-weight: 700 !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
</style>
